import * as T_T from 'cryface';
import { cloneDeep } from 'lodash';

export function hybridShareCommunityOwnershipOptions(vs: any) {
    const owner = T_T.simpleDetect(vs.Data.find((v: any) => {
        return v['Key'] === 'Owner';
    })) ? vs.Data.find((v: any) => {
        return v['Key'] === 'Owner';
    }) : {
            'Key': 'Owner',
            'Value': 0,
        };
    const renter = T_T.simpleDetect(vs.Data.find((v: any) => {
        return v['Key'] === 'Renter';
    })) ? vs.Data.find((v: any) => {
        return v['Key'] === 'Renter';
    }) : {
            'Key': 'Renter',
            'Value': 0,
        };
    const sum = Number(owner['Value']) + Number(renter['Value']);
    const options = {
        rifoStory: {
            title: ``,
            value: ``,
            owner: Math.round(owner['Value'] / sum * 10000) / 100,
            renter: Math.round(renter['Value'] / sum * 10000) / 100,
            sum: sum,
        },
    };
    return options;
}
